<template>

  <rpm-card-list
    title="Usuários"
    :data="users"
    :loading="loading"
    :pagination="pagination"
    @change-page="getPersons"
    grid-class="xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 gap-6"
  >
    <template #search>
      <section class="grid md:grid-cols-2 grid-cols-1 gap-x-6 gap-y-3 w-full">
        <rpm-input
          placeholder="Nome"
          v-model="searchForm.name"
        ></rpm-input>

        <rpm-input
          placeholder="Usuário"
          v-model="searchForm.username"
        ></rpm-input>
      </section>
    </template>

    <template #actions="{ item }">
      <rpm-button
        color="transparent"
        icon="fa-solid fa-square-up-right"
        tooltip-text="Ver mais"
        :to="{ name: 'UserShow', params: { id:item.id } }"
      />
    </template>

    <template #badges="{ item }">
      <badge
        :class="item.enabled ? 'bg-green-500' : 'bg-slate-400'"
        text-case=""
      >
        {{ item.enabled ? 'Habilitado' : 'Desabilitado' }}
      </badge>
    </template>

    <template #info="{ item }">
      <span class="font-bold text-lg capitalize"> {{ item.name }} </span>
      <span class="text-sm"> <b>Usuário:</b> {{ item.username }} </span>
      <span class="text-sm"> <b>ID:</b> {{ item.id }} </span>
    </template>
  </rpm-card-list>

</template>


<script>

import { request } from "#repositories/repository";
import usersRepository from "#repositories/usersRepository";
import RpmCardList from "#components/RpmCardList.vue";
import Badge from "#components/Badge.vue";

export default {
  name: "Users",
  components: {
    RpmCardList,
    Badge
  },
  data() {
    return {
      users: [],
      loading: true,
      searchTimer: null,
      searchForm: {
        name: this.$route.query.name,
        username: this.$route.query.username,
      },
      pagination: {
        page: this.$route.query.page ?? 1,
        per_page: 18,
        last_page: 0,
        links: []
      },
    }
  },
  methods: {
    switchPersonType(type){
      switch (type) {
        case 'F': return 'Física';
        case 'J': return 'Jurídica';
      }
    },
    async getPersons(page = 0) {
      if(page != 0) this.pagination.page = page;

      this.loading = true;

      this.$router.push({
         path: this.$route.path, 
         query: {
          page: this.pagination.page,
          name: this.searchForm.name,
          username: this.searchForm.username
        } 
      });

      this.users = request.pagination(
        await usersRepository.fetchAllUsers({
          name: this.searchForm.name,
          username: this.searchForm.username,
          ...this.pagination
        }),
        this.pagination
      );

      this.loading = false;
    },
    searchPerson(){
      clearTimeout(this.searchTimer);

      this.searchTimer = setTimeout(() => {
        this.pagination.page = 1;
        this.getPersons();
      }, 750);
    }
  },
  watch: {
    'searchForm.name':'searchPerson',
    'searchForm.username':'searchPerson',
  },
  mounted() {
    this.getPersons();
  },
}

</script>
